import {
  Control,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
} from "react-hook-form";
import { useDroppable } from "@dnd-kit/core";
import {
  CreatingSearchHHForm,
  TEditableListItem,
  createEditableListItem,
} from "../constans";
import AddIcon from "@mui/icons-material/Add";
import { SortableEditableListItem } from "./SortableEditableListItem";

import styles from "./RequirementsDndLists.module.scss";

type TListName = "mandatory" | "priority" | "optional";

interface Props {
  control: Control<CreatingSearchHHForm>;
  name: TListName;
  title: string;
  placeholder: string;
  fields: FieldArrayWithId<CreatingSearchHHForm, TListName, "id">[];
  append: UseFieldArrayAppend<CreatingSearchHHForm, TListName>;
  remove: UseFieldArrayRemove;
  isDisabled?: boolean;
  containerDndId: string;
  getItemDndId: (listName: TListName, uid: string) => string;
  error?: string;
}

export const SortableEditableList = ({
  control,
  name,
  title,
  placeholder,
  fields,
  append,
  remove,
  isDisabled,
  containerDndId,
  getItemDndId,
  error,
}: Props) => {
  const { setNodeRef, isOver } = useDroppable({
    id: containerDndId,
    disabled: isDisabled,
  });

  const handleAddItem = () => {
    append(createEditableListItem() as TEditableListItem);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>

        <button
          type="button"
          className={styles.addButton}
          onClick={handleAddItem}
          disabled={isDisabled}
        >
          <AddIcon sx={{ width: 18, height: 18 }} />
          Добавить
        </button>
      </div>

      <div
        ref={setNodeRef}
        className={`${styles.list} ${isOver ? styles.listOver : ""}`}
      >
        {!fields.length && (
          <button
            type="button"
            className={styles.emptyState}
            onClick={handleAddItem}
            disabled={isDisabled}
          >
            + Добавить первый пункт
          </button>
        )}

        {fields.map((field, index) => (
          <SortableEditableListItem
            key={field.id}
            control={control}
            name={name}
            index={index}
            uid={field.uid}
            placeholder={placeholder}
            isDisabled={isDisabled}
            dndId={getItemDndId(name, field.uid)}
            onRemove={() => remove(index)}
          />
        ))}
      </div>

      {error && <div className={styles.errorText}>{error}</div>}
    </div>
  );
};
